module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"exportScoreboard":"Obtenir les scores en CSV"},"en":{"exportScoreboard":"Get scoreboard as CSV"}}')
  delete Component.options._Ctor
}
